import _ from "lodash";
export const getMinutesFromTimestamp = timestamp => {
  return Math.floor(timestamp / (1000 * 60)) % 60;
};

export const getSecondsFromTimestamp = timestamp => {
  return Math.floor(timestamp / 1000) % 60;
};

export const formatTimer = timer => {
  if (!timer) return "00:00";
  const minutes = getMinutesFromTimestamp(timer);
  const remainingSeconds = getSecondsFromTimestamp(timer);

  const mm = minutes > 9 ? minutes : `0${minutes}`;
  const ss = remainingSeconds > 9 ? remainingSeconds : `0${remainingSeconds}`;

  return `${mm}:${ss}`;
};

export const prepareAttachmentFromBlob = (blob, durationMs = 0) => {
  const audioURL = blob?.blobURL;

  const attachment = {
    url: audioURL,
    file: blob?.blob,
    type: "AUDIO",
    name: "",
    mimeType: blob?.blob?.type,
    metadata: {
      size: _.get(blob, "blob.size", 0),
      duration: durationMs, // Duration in milliseconds
    },
  };
  return attachment;
};

export const convertRecordedBlobToBase64 = async recordedBlob => {
  try {
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = error => reject(error);
      reader.readAsDataURL(recordedBlob);
    });
  } catch (error) {}
};
